import React, { useState, useEffect, useRef, useCallback } from 'react';

const API_BASE = "https://adria.terrier-ule.ts.net";

const ROOM_ORDER = [
  ...Array.from({length:10},(_,i)=>`${201+i}호`),
  ...Array.from({length:8}, (_,i)=>`${301+i}호`),
  ...Array.from({length:8}, (_,i)=>`${401+i}호`),
  ...Array.from({length:5}, (_,i)=>`${501+i}호`),
  ...Array.from({length:3}, (_,i)=>`${601+i}호`),
];

// ── 날짜 선택 패드 ─────────────────────────────────────────────
function DatePicker({ initialValue, onConfirm, onCancel }) {
  const now = new Date();
  const curY = now.getFullYear();
  const parse = (v) => {
    if (v) { const m = v.match(/(\d{4})년\s*(\d{1,2})월\s*(\d{1,2})일/); if (m) return { mo: +m[2], d: +m[3] }; }
    return { mo: now.getMonth()+1, d: now.getDate() };
  };
  const init = parse(initialValue);
  const [mo, setMo] = useState(init.mo);
  const [d,  setD]  = useState(init.d);

  // 현재 월 ±2
  const months = Array.from({length:5}, (_,i) => {
    let m = now.getMonth()+1 - 2 + i;
    if(m<1) m+=12; if(m>12) m-=12;
    return m;
  });
  const daysInMonth = new Date(curY, mo, 0).getDate();
  const days = Array.from({length:daysInMonth}, (_,i) => i+1);
  const safeD = Math.min(d, daysInMonth);

  const selStyle = (active) => ({
    padding:'10px 16px', border:'none', borderRadius:'8px', cursor:'pointer',
    fontSize:'15px', fontWeight: active?'700':'400',
    backgroundColor: active?'#4f46e5':'transparent',
    color: active?'#fff':'#374151', transition:'all .15s',
  });

  const ColSel = ({items, value, onChange, fmt}) => (
    <div style={{display:'flex',flexDirection:'column',gap:'2px',maxHeight:'180px',overflowY:'auto',
                 scrollbarWidth:'thin',padding:'4px 0'}}>
      {items.map(v=>(
        <button key={v} onClick={()=>onChange(v)} style={selStyle(value===v)}>
          {fmt ? fmt(v) : v}
        </button>
      ))}
    </div>
  );

  return (
    <div style={{position:'fixed',inset:0,zIndex:3000,backgroundColor:'rgba(0,0,0,0.7)',
                 display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',
                 fontFamily:'"Pretendard",sans-serif'}}>
      <div style={{backgroundColor:'#fff',borderRadius:'16px',overflow:'hidden',
                   width:'80%',maxWidth:'300px',boxShadow:'0 20px 60px rgba(0,0,0,0.4)'}}>
        <div style={{padding:'14px 20px',backgroundColor:'#1a1f2e',display:'flex',
                     justifyContent:'space-between',alignItems:'center'}}>
          <span style={{color:'#fff',fontWeight:'700',fontSize:'15px'}}>📅 날짜 선택</span>
          <span style={{color:'#9ca3af',fontSize:'12px'}}>{curY}년 {String(mo).padStart(2,'0')}월 {String(safeD).padStart(2,'0')}일</span>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'1px',backgroundColor:'#e5e7eb'}}>
          {[['월', months, mo, setMo, v=>v+'월'],
            ['일', days,   safeD, setD,  v=>v+'일']
          ].map(([label, items, val, setter, fmt])=>(
            <div key={label} style={{backgroundColor:'#fff',padding:'8px 6px'}}>
              <div style={{textAlign:'center',fontSize:'11px',color:'#9ca3af',
                           fontWeight:'600',marginBottom:'6px',letterSpacing:'1px'}}>{label}</div>
              <ColSel items={items} value={val} onChange={setter} fmt={fmt}/>
            </div>
          ))}
        </div>
        <div style={{display:'flex',gap:'8px',padding:'12px 16px',backgroundColor:'#f9fafb'}}>
          <button onClick={onCancel}
            style={{flex:1,padding:'10px',backgroundColor:'#6b7280',color:'#fff',border:'none',
                    borderRadius:'8px',fontSize:'13px',cursor:'pointer',fontWeight:'600'}}>취소</button>
          <button onClick={()=>onConfirm(`${curY}년 ${String(mo).padStart(2,'0')}월 ${String(safeD).padStart(2,'0')}일`)}
            style={{flex:2,padding:'10px',backgroundColor:'#4f46e5',color:'#fff',border:'none',
                    borderRadius:'8px',fontSize:'13px',cursor:'pointer',fontWeight:'700'}}>✅ 확인</button>
        </div>
      </div>
    </div>
  );
}

// ── 서명 패드 ──────────────────────────────────────────────────
function SignaturePad({ onConfirm, onCancel }) {
  const canvasRef=useRef(null);
  const drawing=useRef(false);
  const lastPos=useRef(null);

  useEffect(()=>{
    const canvas=canvasRef.current;if(!canvas)return;
    canvas.width=canvas.offsetWidth;canvas.height=canvas.offsetHeight;
  },[]);

  const getPos=(e,canvas)=>{
    const rect=canvas.getBoundingClientRect(),src=e.touches?e.touches[0]:e;
    return{x:src.clientX-rect.left,y:src.clientY-rect.top};
  };
  const startDraw=(e)=>{e.preventDefault();drawing.current=true;lastPos.current=getPos(e,canvasRef.current);};
  const draw=(e)=>{
    e.preventDefault();if(!drawing.current)return;
    const canvas=canvasRef.current,ctx=canvas.getContext('2d'),pos=getPos(e,canvas);
    ctx.beginPath();ctx.moveTo(lastPos.current.x,lastPos.current.y);ctx.lineTo(pos.x,pos.y);
    ctx.strokeStyle='#1a1a2e';ctx.lineWidth=4;ctx.lineCap='round';ctx.lineJoin='round';ctx.stroke();
    lastPos.current=pos;
  };
  const endDraw=()=>{drawing.current=false;};
  const clear=()=>{const canvas=canvasRef.current,ctx=canvas.getContext('2d');ctx.clearRect(0,0,canvas.width,canvas.height);};
  const confirm=()=>{
    const canvas=canvasRef.current,dataUrl=canvas.toDataURL('image/png');
    const ctx=canvas.getContext('2d'),data=ctx.getImageData(0,0,canvas.width,canvas.height).data;
    let hasInk=false;
    for(let i=3;i<data.length;i+=4){if(data[i]>10){hasInk=true;break;}}
    if(!hasInk){alert('서명을 입력해주세요');return;}
    onConfirm(dataUrl);
  };

  return(
    <div style={{position:'fixed',inset:0,zIndex:3000,backgroundColor:'rgba(0,0,0,0.85)',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',fontFamily:'"Pretendard",sans-serif'}}>
      <div style={{backgroundColor:'#fff',borderRadius:'16px',overflow:'hidden',width:'90%',maxWidth:'480px',boxShadow:'0 20px 60px rgba(0,0,0,0.5)'}}>
        <div style={{padding:'16px 20px',backgroundColor:'#1a1f2e',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <span style={{color:'#fff',fontWeight:'700',fontSize:'15px'}}>✍️ 서명</span>
          <span style={{color:'#9ca3af',fontSize:'12px'}}>손가락 또는 마우스로 서명하세요</span>
        </div>
        <canvas ref={canvasRef} style={{display:'block',width:'100%',height:'200px',cursor:'crosshair',touchAction:'none',backgroundColor:'#f8faff'}}
          onMouseDown={startDraw} onMouseMove={draw} onMouseUp={endDraw} onMouseLeave={endDraw}
          onTouchStart={startDraw} onTouchMove={draw} onTouchEnd={endDraw}/>
        <div style={{display:'flex',gap:'8px',padding:'12px 16px',backgroundColor:'#f9fafb'}}>
          <button onClick={clear}    style={{flex:1,padding:'10px',backgroundColor:'#e5e7eb',border:'none',borderRadius:'8px',fontSize:'13px',cursor:'pointer',fontWeight:'600'}}>🗑️ 지우기</button>
          <button onClick={onCancel} style={{flex:1,padding:'10px',backgroundColor:'#6b7280',color:'#fff',border:'none',borderRadius:'8px',fontSize:'13px',cursor:'pointer',fontWeight:'600'}}>취소</button>
          <button onClick={confirm}  style={{flex:1,padding:'10px',backgroundColor:'#4f46e5',color:'#fff',border:'none',borderRadius:'8px',fontSize:'13px',cursor:'pointer',fontWeight:'600'}}>✅ 완료</button>
        </div>
      </div>
    </div>
  );
}

// ── 메인 ──────────────────────────────────────────────────────
export default function DocFormView() {
  const token=new URLSearchParams(window.location.search).get('token');

  // step: 'form'(문서작성) | 'done'(완료)
  const [step,       setStep]       = useState('form');
  const [tmplInfo,   setTmplInfo]   = useState(null);
  const [imgBase64,  setImgBase64]  = useState(null);
  const [fields,     setFields]     = useState([]);
  const [values,     setValues]     = useState({});
  const [errors,     setErrors]     = useState({});
  const [sigPad,     setSigPad]     = useState(null);
  const [datePick,   setDatePick]   = useState(null); // field.id
  const [submitting, setSubmitting] = useState(false);
  const [pageError,  setPageError]  = useState('');
  const [activePage, setActivePage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [pageImgs,   setPageImgs]   = useState({});  // {pageIdx: base64}

  const canvasRef      = useRef(null);
  const imgRef         = useRef(null);
  const imgSizeRef     = useRef({w:1,h:1});
  const displaySizeRef = useRef({w:1,h:1});
  const sigImgCache    = useRef({});

  // 토큰 유효성 확인
  useEffect(()=>{
    if(!token){setPageError('잘못된 링크입니다');return;}
    fetch(`${API_BASE}/api/docform/form/${token}`)
      .then(r=>r.ok?r.json():r.json().then(d=>{throw new Error(d.detail);}))
      .then(d=>{setTmplInfo(d);setFields(Array.isArray(d.fields)?d.fields:[]);})
      .catch(e=>setPageError(e.message||'링크를 불러올 수 없습니다'));
  },[token]);

  // 이미지 로드 (step=form 진입 시)
  useEffect(()=>{
    if(!token)return;
    fetch(`${API_BASE}/api/docform/form/${token}/image?page=0`)
      .then(r=>r.json()).then(d=>{
        setImgBase64(d.data);
        setPageImgs({0: d.data});
        const total = d.total_pages || 1;
        setTotalPages(total);
        // 나머지 페이지 미리 로드
        for(let p=1; p<total; p++){
          fetch(`${API_BASE}/api/docform/form/${token}/image?page=${p}`)
            .then(r=>r.json()).then(d2=>{
              setPageImgs(prev=>({...prev,[p]:d2.data}));
            });
        }
      })
      .catch(()=>setPageError('이미지를 불러올 수 없습니다'));
  },[step,token]);

  const bgImgCache     = useRef({});

  useEffect(()=>{
    const imgSrc = pageImgs[activePage] || imgBase64;
    if(!imgSrc)return;
    const cached = bgImgCache.current[imgSrc];
    if(cached && cached.complete){
      imgRef.current=cached;
      imgSizeRef.current={w:cached.naturalWidth,h:cached.naturalHeight};
      renderCanvas();
      return;
    }
    const img=new Image();
    img.onload=()=>{
      bgImgCache.current[imgSrc]=img;
      imgRef.current=img;
      imgSizeRef.current={w:img.naturalWidth,h:img.naturalHeight};
      renderCanvas();
    };
    img.src=imgSrc;
    bgImgCache.current[imgSrc]=img;
  },[imgBase64, activePage, pageImgs]);

  const renderCanvas=useCallback(()=>{
    const canvas=canvasRef.current,img=imgRef.current;
    if(!canvas||!img)return;
    const containerW=canvas.parentElement.clientWidth;
    const ratio=containerW/imgSizeRef.current.w;
    const displayH=imgSizeRef.current.h*ratio;
    const{w:iw,h:ih}=imgSizeRef.current;
    const dpr=Math.max(window.devicePixelRatio||1, iw/containerW); // 원본해상도 보존
    canvas.width=containerW*dpr;canvas.height=displayH*dpr;
    canvas.style.width=containerW+'px';canvas.style.height=displayH+'px';
    displaySizeRef.current={w:containerW,h:displayH};
    const ctx=canvas.getContext('2d');
    ctx.setTransform(1,0,0,1,0,0);
    ctx.clearRect(0,0,canvas.width,canvas.height);
    ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';
    ctx.scale(dpr,dpr);
    ctx.drawImage(img,0,0,containerW,displayH);

    fields.filter(f=>(f.page||0)===activePage).forEach(f=>{
      const fx=(f.x/iw)*containerW,fy=(f.y/ih)*displayH;
      const fw=(f.w/iw)*containerW,fh=(f.h/ih)*displayH;
      const val=values[f.id],hasErr=errors[f.id];

      if(f.type==='signature'&&val){
        const cached = sigImgCache.current[val];
        if(cached && cached.complete){
          ctx.drawImage(cached,fx,fy,fw,fh);
        }else{
          const si=new Image();
          si.onload=()=>{ sigImgCache.current[val]=si; renderCanvas(); };
          si.src=val;
          sigImgCache.current[val]=si;
        }
        return;
      }
      if(f.type==='checkbox'){
        ctx.fillStyle=hasErr?'rgba(239,68,68,0.06)':'rgba(148,163,184,0.12)';ctx.fillRect(fx,fy,fw,fh);
        ctx.strokeStyle=hasErr?'#ef4444':'#94a3b8';ctx.lineWidth=1.5;ctx.strokeRect(fx,fy,fw,fh);
        if(val){ctx.strokeStyle='#4f46e5';ctx.lineWidth=2.5;ctx.beginPath();ctx.moveTo(fx+fw*.15,fy+fh*.5);ctx.lineTo(fx+fw*.4,fy+fh*.75);ctx.lineTo(fx+fw*.85,fy+fh*.2);ctx.stroke();}
        return;
      }
      // 텍스트 (배경 투명) - 폭(w) 무시, 높이(h) 기준 폰트 크기로 자연스럽게 펼침
      if(val){
        const size = Math.max(11,fh*.55);
        ctx.font=`${size}px "Pretendard",sans-serif`;
        ctx.textBaseline='middle';
        ctx.fillStyle=hasErr?'#ef4444':'#1a1a2e';
        ctx.fillText(val,fx+5,fy+fh/2);
      }else{
        ctx.fillStyle=hasErr?'#ef4444':'#94a3b8';ctx.font=`${Math.max(10,fh*.45)}px "Pretendard",sans-serif`;ctx.textBaseline='middle';
        ctx.fillText(f.placeholder||f.label||'',fx+5,fy+fh/2);
      }
      if(f.required&&!val){ctx.fillStyle='#ef4444';ctx.font='bold 11px sans-serif';ctx.fillText('*',fx+fw-9,fy+5);}
    });
  },[fields,values,errors,activePage]);

  useEffect(()=>{renderCanvas();},[renderCanvas]);

  const onCanvasClick=useCallback((e)=>{
    const canvas=canvasRef.current;if(!canvas)return;
    const rect=canvas.getBoundingClientRect(),cx=e.clientX-rect.left,cy=e.clientY-rect.top;
    const{w:dispW,h:dispH}=displaySizeRef.current;
    const{w:iw,h:ih}=imgSizeRef.current;
    const pageFields = fields.filter(f=>(f.page||0)===activePage);
    for(let i=pageFields.length-1;i>=0;i--){
      const f=pageFields[i];
      const fx=(f.x/iw)*dispW,fy=(f.y/ih)*dispH;
      const fw=(f.w/iw)*dispW,fh=(f.h/ih)*dispH;
      if(cx>=fx&&cx<=fx+fw&&cy>=fy&&cy<=fy+fh){
        if(f.type==='text'){
          const cur=values[f.id]||'',maxLen=f.maxlength||100;
          const hint=f.placeholder?`"${f.placeholder}" 라고 입력하세요`:'';
          const input=window.prompt(`${f.label||'입력'}${f.required?' (필수)':''}${hint?'\n'+hint:''}`,cur);
          if(input===null)return;
          const trimmed=input.trim();
          if(f.placeholder&&trimmed!==f.placeholder){
            alert(`입력이 일치하지 않습니다.\n"${f.placeholder}" 라고 정확히 입력해주세요.`);
            setErrors(er=>({...er,[f.id]:true}));return;
          }
          setValues(v=>({...v,[f.id]:trimmed.slice(0,maxLen)}));setErrors(er=>({...er,[f.id]:false}));
        }else if(f.type==='date'){setDatePick(f.id);
        }else if(f.type==='checkbox'){
          setValues(v=>({...v,[f.id]:!v[f.id]}));setErrors(er=>({...er,[f.id]:false}));
        }else if(f.type==='signature'){setSigPad(f.id);}
        return;
      }
    }
  },[fields,values,activePage]);

  const onSignConfirm=(dataUrl)=>{
    setValues(v=>({...v,[sigPad]:dataUrl}));setErrors(er=>({...er,[sigPad]:false}));setSigPad(null);
  };

  const handleSubmit=async()=>{
    const newErrors={};let hasErr=false;
    fields.forEach(f=>{if(f.required&&!values[f.id]){newErrors[f.id]=true;hasErr=true;}});
    if(hasErr){setErrors(newErrors);alert('필수 항목을 모두 채워주세요');return;}
    setSubmitting(true);
    try{
      const fd=new FormData();
      fd.append('inputs',JSON.stringify(values));
      fd.append('room_no',tmplInfo?.room_no||'');
      fd.append('user_name',tmplInfo?.user_name||'');
      const res=await fetch(`${API_BASE}/api/docform/form/${token}/submit`,{method:'POST',body:fd});
      if(res.ok)setStep('done');
      else{const d=await res.json();setPageError(d.detail||'제출 실패');}
    }catch{setPageError('제출 실패');}
    finally{setSubmitting(false);}
  };

  // ── 에러 화면 ────────────────────────────────────────────────
  if(pageError)return(
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh',backgroundColor:'#f3f4f6',fontFamily:'"Pretendard",sans-serif'}}>
      <div style={{textAlign:'center'}}><div style={{fontSize:'40px',marginBottom:'12px'}}>⚠️</div><div style={{color:'#dc2626',fontSize:'15px'}}>{pageError}</div></div>
    </div>
  );

  // ── 완료 화면 ────────────────────────────────────────────────
  if(step==='done')return(
    <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',minHeight:'100vh',backgroundColor:'#f3f4f6',fontFamily:'"Pretendard",sans-serif'}}>
      <div style={{backgroundColor:'#fff',padding:'40px 30px',borderRadius:'20px',boxShadow:'0 4px 20px rgba(0,0,0,0.1)',textAlign:'center',maxWidth:'320px'}}>
        <div style={{fontSize:'56px',marginBottom:'16px'}}>✅</div>
        <div style={{fontWeight:'700',fontSize:'18px',color:'#1f2937',marginBottom:'8px'}}>제출 완료</div>
        <div style={{color:'#6b7280',fontSize:'13px'}}>문서가 성공적으로 제출되었습니다.</div>
      </div>
    </div>
  );

  // ── 로딩 ─────────────────────────────────────────────────────
  if(!tmplInfo)return(
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh',backgroundColor:'#f3f4f6'}}>
      <div style={{color:'#9ca3af',fontSize:'14px'}}>불러오는 중...</div>
    </div>
  );


  if(!imgBase64)return(
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh',backgroundColor:'#f3f4f6'}}>
      <div style={{color:'#9ca3af',fontSize:'14px'}}>문서를 불러오는 중...</div>
    </div>
  );

  const reqFields=fields.filter(f=>f.required),missing=reqFields.filter(f=>!values[f.id]);

  return(
    <div style={{minHeight:'100vh',backgroundColor:'#f3f4f6',fontFamily:'"Pretendard",sans-serif'}}>
      {/* 헤더 */}
      <div style={{position:'sticky',top:0,zIndex:100,backgroundColor:'#1a1f2e',padding:'12px 16px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 12px rgba(0,0,0,0.3)'}}>
        <div>
          <div style={{color:'#fff',fontWeight:'700',fontSize:'14px'}}>📝 {tmplInfo.title}</div>
          <div style={{color:'#9ca3af',fontSize:'11px',marginTop:'2px'}}>{tmplInfo?.room_no||''} · {tmplInfo?.user_name||''}</div>
        </div>
        <button onClick={handleSubmit} disabled={submitting} style={{padding:'10px 18px',backgroundColor:submitting?'#6b7280':missing.length>0?'#d97706':'#059669',color:'#fff',border:'none',borderRadius:'9px',cursor:submitting?'not-allowed':'pointer',fontSize:'13px',fontWeight:'700'}}>
          {submitting?'⏳...':`✅ 제출${missing.length>0?` (${missing.length}개 미입력)`:''}`}
        </button>
      </div>
      <div style={{backgroundColor:'#eff6ff',borderBottom:'1px solid #bfdbfe',padding:'8px 16px',fontSize:'12px',color:'#1d4ed8'}}>
        💡 각 입력 칸을 탭/클릭하여 내용을 입력하세요{reqFields.length>0&&' · * 필수 항목'}
      </div>

      {/* 문서 */}
      <div style={{padding:'12px',maxWidth:'800px',margin:'0 auto'}}>
        {totalPages > 1 && (
          <div style={{display:'flex',gap:'6px',marginBottom:'10px',justifyContent:'center'}}>
            {Array.from({length:totalPages},(_,i)=>(
              <button key={i} onClick={()=>setActivePage(i)}
                style={{padding:'8px 18px',borderRadius:'8px',border:'none',cursor:'pointer',fontSize:'13px',fontWeight:'700',
                        backgroundColor: activePage===i ? '#4f46e5' : '#e2e8f0',
                        color: activePage===i ? '#fff' : '#64748b'}}>
                {i+1}
              </button>
            ))}
          </div>
        )}
        <div style={{backgroundColor:'#fff',borderRadius:'12px',overflow:'hidden',boxShadow:'0 4px 20px rgba(0,0,0,0.1)'}}>
          <canvas ref={canvasRef} style={{display:'block',width:'100%',cursor:'pointer',touchAction:'manipulation'}} onClick={onCanvasClick}/>
        </div>
      </div>



      {datePick&&<DatePicker initialValue={values[datePick]||''} onConfirm={v=>{setValues(va=>({...va,[datePick]:v}));setErrors(er=>({...er,[datePick]:false}));setDatePick(null);}} onCancel={()=>setDatePick(null)}/>}
      {sigPad&&<SignaturePad onConfirm={onSignConfirm} onCancel={()=>setSigPad(null)}/>}
    </div>
  );
}
